/* eslint-disable no-unused-vars */

import {
  CHART_DATA_PROP,
  CONDITIONAL_SELECT,
  CONDITIONAL_TEXT_FIELD,
  CONTROL_TYPE_COMPONENT,
  DATASOURCE_EDITOR,
  DATASOURCE_TYPE_ENUM,
  DATASOURCE_TYPE_EXTERNALDATASOURCE,
  DATASOURCE_TYPE_SMARTSOLVEDATA,
  ICON_FIELD,
  LINK_TEXT_FIELD,
  MAPPING_TEXT_FIELD,
  QUERY_PARAM_FIELD,
  RADIO,
  SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE,
  SELECT,
  TEXT_FIELD,
  TEXT_VIEW,
} from './editor.constants';
import {
  BUTTON_DEFAULT_LABELS,
  BUTTON_TYPES,
  DATALOOKUP_TYPE_EXTERNAL_API,
  FORM_MODEL_ATTRIBUTES,
  ICON_LABELS,
  ICON_TYPES,
} from './form-manager.constants';

const YES_NO_VALUES = [
  {
    value: true,
    label: 'Yes',
  },
  {
    value: false,
    label: 'No',
  },
];

const YES_VALUE = [
  {
    value: true,
    label: 'Yes',
  },
];

const COMMAND_NAME_VALUES = [
  { value: 'Inherit', label: 'Inherit' },
  { value: 'Save', label: 'Save' },
  { value: 'Submit', label: 'Submit' },
  { value: 'Delete', label: 'Delete' },
  { value: 'Evaluate', label: 'Evaluate' },
];

const YES_NO_CONDITIONAL_VALUES = [
  ...YES_NO_VALUES,
  { value: 'conditional', label: 'Conditional...' },
];

const OFFICE_ONLINE_OPTION_COLLABORATOR = 'COLLABORATOR';
const OFFICE_ONLINE_OPTION_DOCUMENTOWNER = 'DOCUMENTOWNER';

const OFFICE_ONLINE_OPTIONS_VALUES = [
  {
    value: OFFICE_ONLINE_OPTION_COLLABORATOR,
    label: 'Collaborator',
  },
  {
    value: OFFICE_ONLINE_OPTION_DOCUMENTOWNER,
    label: 'Document Owner',
  },
  { value: 'conditional', label: 'Conditional...' },
];

const SCORM_CONTENT_TYPE_OPTIONS_VALUES = [
  {
    value: 'INITIAL',
    label: 'Initial',
  },
  {
    value: 'REFRESHER',
    label: 'Refresher',
  },
  {
    value: 'REVISION',
    label: 'Revison',
  },
  { value: 'conditional', label: 'Conditional...' },
];

const SCORM_LAUNCH_OPTIONS_VALUES = [
  {
    value: 'PREVIEW',
    label: 'Preview',
  },
  {
    value: 'LAUNCH',
    label: 'Launch',
  },
  { value: 'conditional', label: 'Conditional...' },
];

const ORIENTATION_VALUES = [
  {
    value: 'DEFAULT',
    label: 'Default',
  },
  {
    value: 'HORIZONTAL',
    label: 'Horizontal',
  },
  {
    value: 'HORIZONTALWITHOUTLABEL',
    label: 'Horizontal Without Label',
  },
];

const REGULATORY_TERMS_VALUES = [
  {
    value: 'IMDRF',
    label: 'IMDRF',
  },
  {
    value: 'CDRH',
    label: 'CDRH',
  },
  {
    value: 'MEDDRA',
    label: 'MEDDRA',
  },
  { value: 'conditional', label: 'Conditional...' },
];

const FILE_VIEWER_CONTENT_TYPE_VALUES = [
  { value: 'Either', label: 'Either' },
  { value: 'Primary', label: 'Primary' },
  { value: 'Secondary', label: 'Secondary' },
  { value: 'PortalCheckedInPrimary', label: 'PortalCheckedInPrimary' },
  { value: 'conditional', label: 'Conditional...' },
];

const LINK_TYPE_VALUES = [
  { value: '0', label: 'New Window' },
  { value: '1', label: 'Popup Window' },
  { value: '2', label: 'Current Window' },
];

const FORMAT_TYPE_VALUES = [
  { value: 'dateTime', label: 'Date Time' },
  { value: 'string', label: 'String' },
];

const GRID_TYPES_VALUES = [
  { value: 'Attachment', label: 'Attachment' },
  { value: 'ChildAttachment', label: 'Child Attachment' },
  { value: 'Content', label: 'Content' },
  { value: 'CompareContentHistory', label: 'Compare Content History' },
  { value: 'BatchDocuments', label: 'Batch Documents' },
  { value: '', label: 'Low Volume' },
];

const BUTTON_TYPE_VALUES = [
  {
    value: BUTTON_TYPES.SAVE_AND_SIGNOFF,
    label: BUTTON_DEFAULT_LABELS.Save,
  },
  {
    value: BUTTON_TYPES.SAVE_WITHOUT_SIGNOFF,
    label: BUTTON_DEFAULT_LABELS.SaveNoSignOff,
  },
  {
    value: BUTTON_TYPES.SAVE_PUBLIC_DRAFT,
    label: BUTTON_DEFAULT_LABELS.SavePublicDraft,
  },
  {
    value: BUTTON_TYPES.DELETE,
    label: BUTTON_DEFAULT_LABELS.Delete,
  },
  {
    value: BUTTON_TYPES.CANCEL,
    label: BUTTON_DEFAULT_LABELS.Cancel,
  },
  {
    value: BUTTON_TYPES.OTHER,
    label: BUTTON_DEFAULT_LABELS.Other,
  },
];

const BUTTON_BATCH_TYPE_VALUES = [
  {
    value: BUTTON_TYPES.SUBMIT_BATCH,
    label: BUTTON_DEFAULT_LABELS.SubmitBatch,
  },
];

const BUTTON_BATCH_ICON_VALUES = [
  { value: ICON_TYPES.NONE, label: ICON_LABELS.None },
  { value: ICON_TYPES.SUBMIT, label: ICON_LABELS.Submit },
  { value: ICON_TYPES.SAVE, label: ICON_LABELS.Save },
];

const LOOKUP_TYPE_VALUES = [
  { value: 'AUTOCOMPLETE', label: 'Yes' },
  { value: '', label: 'No' },
];

const SOURCE_TYPE_VALUES = [
  { value: DATASOURCE_TYPE_ENUM[DATASOURCE_TYPE_SMARTSOLVEDATA], label: 'SmartSolve Data' },
  {
    value: DATASOURCE_TYPE_ENUM[DATASOURCE_TYPE_EXTERNALDATASOURCE],
    label: 'External Data Source',
  },
  {
    value: DATALOOKUP_TYPE_EXTERNAL_API,
    label: 'External API',
  },
];

const DATASOURCE_SOURCE_TYPE_VALUES = [
  { value: DATASOURCE_TYPE_ENUM[DATASOURCE_TYPE_SMARTSOLVEDATA], label: 'SmartSolve Data' },
  {
    value: DATASOURCE_TYPE_ENUM[DATASOURCE_TYPE_EXTERNALDATASOURCE],
    label: 'External Data Source',
  },
];

const SAVED_SEARCH_TYPE_VALUES = [
  { value: '', label: 'Saved Search' },
  { value: 'CompareDocumentHistory', label: 'Compare Document History' },
  { value: SAVED_SEARCH_TRAINING_SESSION_SIGNUP_TYPE, label: 'Training Session Signup' },
];

const INITIAL_VALUE = {
  label: 'Initial Value',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'defaultValue',
};

const SET_VALUE = {
  label: 'Set Value',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'setValue',
};

const LOOKUP_TYPE = {
  label: 'Enable Lookup',
  type: RADIO,
  values: LOOKUP_TYPE_VALUES,
  name: 'lookupType',
  defaultValueProp: '',
};

const FORCE_VALID_SELECTION = {
  label: 'Force Valid Selection',
  type: RADIO,
  values: YES_NO_VALUES,
  name: 'enforceSelection',
  defaultValueProp: true,
};

const REQUIRED = {
  label: 'Required',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'required',
  defaultValueProp: false,
};

const VALIDATION_ACTIONS = {
  label: 'Validation Actions',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'validationActions',
};

const DATASOURCES_LIST = {
  label: 'Data Sources List',
  type: DATASOURCE_EDITOR,
  name: 'dataSourcesList',
};

const UPDATE_ACTIONS = {
  label: 'Update Actions',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'updateActions',
};

const INTERACTION_ACTIONS = {
  label: 'Interaction Actions',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'interactionActions',
};

const STEP_SIZE = {
  label: 'Step Size',
  type: TEXT_FIELD,
  name: 'stepSize',
};

const HIDDEN = {
  label: 'Hidden',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'hidden',
  defaultValueProp: false,
};

const OFFICE_ONLINE_OPTIONS = {
  label: 'Office Online Options',
  type: CONDITIONAL_SELECT,
  values: OFFICE_ONLINE_OPTIONS_VALUES,
  name: 'officeOnlineOptions',
  defaultValueProp: OFFICE_ONLINE_OPTION_COLLABORATOR,
};

const SCORM_CONTENT_TYPE = {
  label: 'Scorm Content Type',
  type: CONDITIONAL_SELECT,
  values: SCORM_CONTENT_TYPE_OPTIONS_VALUES,
  name: 'scormContentTypeOptions',
  defaultValueProp: 'INITIAL',
};
const SCORM_LAUNCH_OPTIONS = {
  label: 'Scorm Launch Options',
  type: CONDITIONAL_SELECT,
  values: SCORM_LAUNCH_OPTIONS_VALUES,
  name: 'scormLaunchOptions',
  defaultValueProp: 'PREVIEW',
};

const VIEW_ONLY = {
  label: 'View Only',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'viewOnly',
  defaultValueProp: false,
};

const DISABLED_WITH_ZOOM = {
  label: 'Disabled with Zoom',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'disabledWithZoom',
  defaultValueProp: false,
};

const DEFAULT_TAB = {
  label: 'Default Tab',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'defaultTab',
};

const DISABLE_ADD = {
  label: 'Disable Add',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'disableAdd',
  defaultValueProp: false,
};

const DISABLE_EDIT = {
  label: 'Disable Edit',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'disableEdit',
  defaultValueProp: false,
};

const DISABLE_DELETE = {
  label: 'Disable Delete',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'disableDelete',
  defaultValueProp: false,
};
const EDIT_ALL_ROWS = {
  label: 'Edit All Rows',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'editAllRows',
  defaultValueProp: true,
};

const ENABLE_COPY = {
  label: 'Enable Copy',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'enableCopy',
  defaultValueProp: false,
};

const EXCLUDE_FIELDS_FROM_COPY = {
  label: 'Exclude Fields From Copy',
  type: MAPPING_TEXT_FIELD,
  name: 'excludedColumnsMappingList',
};

const ALLOW_SORT = {
  label: 'Allow Sort',
  type: SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'allowSort',
  defaultValueProp: false,
};

const ALLOW_MULTIPLE_SELECTION = {
  label: 'Allow Multiple Selection',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'multiSelect',
  defaultValueProp: false,
};

const HEIGHT = {
  label: 'Height',
  type: TEXT_FIELD,
  name: 'height',
};

const WIDTH = {
  label: 'Width',
  type: TEXT_FIELD,
  name: 'width',
};

const LABEL = {
  label: 'Label',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'label',
};

const ICONS_LIST = {
  label: 'Icon',
  type: ICON_FIELD,
  name: 'icon',
};

const ICON_FONT_SIZE_VALUES = [
  { value: 'extraSmall', label: 'Extra Small' },
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

const ICON_FONT_SIZE = {
  label: 'Font Size',
  type: SELECT,
  values: ICON_FONT_SIZE_VALUES,
  name: 'fontSize',
};

const ICON_COLOR_VALUES = [
  { value: 'black', label: 'Black' },
  { value: 'neutral7', label: 'Grey (neutral7)' },
  { value: 'purple', label: 'Purple' },
  { value: 'blue', label: 'Blue' },
  { value: 'orange', label: 'Orange' },
  { value: 'fuchsia', label: 'Fuchsia' },
  { value: 'green', label: 'Green' },
  { value: 'blueDark', label: 'Blue Dark' },
];

const ICON_COLOR = {
  label: 'Color',
  type: SELECT,
  values: ICON_COLOR_VALUES,
  name: 'color',
};

const CONTROL_TYPE = {
  label: 'Control Type',
  type: CONTROL_TYPE_COMPONENT,
  name: 'controlType',
};

const VALIDATE = {
  label: 'Validate',
  type: TEXT_VIEW,
  name: 'validate',
};

const UPDATE = {
  label: 'Update',
  type: TEXT_FIELD,
  name: 'update',
};

const TEXT = {
  label: 'Text',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'text',
};

const DATA_SOURCE_NAME = {
  label: 'Data Source Name',
  type: SELECT,
  name: 'dataSourceKey',
};

const DATA_VALUE_FIELD = {
  label: 'Data Value Field',
  type: SELECT,
  name: 'dataValueField',
};

const DATA_TEXT_FIELD = {
  label: 'Data Text Field',
  type: SELECT,
  name: 'dataTextField',
};

const DATA_SOURCE_FILTER = {
  label: 'Data Source Filter',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'dataSourceFilter',
};

const SOURCE_TYPE = {
  label: 'Source Type',
  type: SELECT,
  name: 'dataLookUpType',
  values: SOURCE_TYPE_VALUES,
};

const DATASOURCE_SOURCE_TYPE = {
  label: 'Source Type',
  type: SELECT,
  name: 'dataLookUpType',
  values: DATASOURCE_SOURCE_TYPE_VALUES,
};

const SAVED_SEARCH_NAME = {
  label: 'Saved Search Name',
  type: SELECT,
  name: 'searchName',
};

const SOURCE_IDENTIFIER = {
  label: 'Source Identifier',
  type: SELECT,
  name: 'dataObject',
};

const FILTER = {
  label: 'Filter',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'filter',
};

const DATA_FILTER = {
  label: 'Data Filter',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'filter',
};

const FORM_DESCRIPTION = {
  label: 'Form Description',
  type: TEXT_FIELD,
  name: 'formDescription',
};

const FORM_HELP_LINK_TEXT = {
  label: 'Help Link Text',
  type: TEXT_FIELD,
  name: 'formHelpLinkText',
};

const FORM_HELP_LINK_URL = {
  label: 'Help Link Url',
  type: LINK_TEXT_FIELD,
  name: 'formHelpLinkUrl',
};

const QUERY_NAME = {
  label: 'Query Name',
  type: SELECT,
  name: 'searchName',
};

const QUERY_PARAM = {
  label: 'Query Param',
  type: QUERY_PARAM_FIELD,
  name: 'paramList',
};

const SORT = {
  label: 'Sort',
  type: TEXT_FIELD,
  name: 'sort',
};

const INITIAL_EMPTY_ROWS = {
  label: 'Initial Empty Rows',
  type: TEXT_FIELD,
  name: 'initialRows',
};

const DATA_MAPPING = {
  label: 'Data Mapping',
  type: MAPPING_TEXT_FIELD,
  name: 'dataMappingList',
};

const TITLE = {
  label: 'Title',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'title',
};

const ORIENTATION = {
  label: 'Orientation',
  type: SELECT,
  values: ORIENTATION_VALUES,
  name: 'orientation',
  defaultValueProp: 'DEFAULT',
};

const HEADER = {
  label: 'Header',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'header',
  defaultValueProp: true,
};

const EMPTY_SECTION_MESSAGE = {
  label: 'Empty Section Message',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'emptySectionMessage',
};

const HEADER_STYLE = {
  label: 'Header Style',
  type: TEXT_FIELD,
  name: 'headerStyle',
};

const COLLAPSIBLE = {
  label: 'Collapsible',
  type: TEXT_FIELD,
  name: 'collapsible',
};

const INITIALLY_COLLAPSED = {
  label: 'Initially Collapsed',
  type: TEXT_FIELD,
  name: 'initiallyCollapsed',
};

const COLLAPSE_ROWS_INITIALLY = {
  label: 'Collapse Rows Initially',
  type: TEXT_FIELD,
  name: 'initiallyCollapsed',
};

const LABEL_FOR_ADD = {
  label: 'Label For Add',
  type: SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'labelForAdd',
};

const ALTERNATIVE_ROW_STYLE = {
  label: 'Alternative Row Style',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'alternativeRowStyle',
};

const HAS_PADDING = {
  label: 'Has Padding',
  type: TEXT_FIELD,
  name: 'hasPadding',
};

const UNIQUE_IDENTIFIER = {
  label: 'Unique Identifier',
  type: TEXT_FIELD,
  name: 'uniqueIdentifier',
};

const SHOW_STATUS = {
  label: 'Show Status',
  type: TEXT_FIELD,
  name: 'showStatus',
};

const DISTINCT_VALUES_ONLY = {
  label: 'Distinct Values Only',
  type: TEXT_FIELD,
  name: 'distinctValuesOnly',
};

const SUPPORT_RICH_TEXT = {
  label: 'Support Rich Text',
  name: 'supportRichText',
  type: RADIO,
  values: YES_NO_VALUES,
  defaultValueProp: false,
};

const ROWS = {
  label: 'Rows',
  type: TEXT_FIELD,
  name: 'rows',
};

const COLUMNS = {
  label: 'Columns',
  type: TEXT_FIELD,
  name: 'columns',
};

const FORM_NAME = {
  label: 'Form Name',
  type: TEXT_FIELD,
  name: 'formName',
};

const LOAD_DYNAMICALLY = {
  label: 'Load Dynamically',
  type: TEXT_FIELD,
  name: 'loadDynamically',
};

const TRANSLATE_DATA = {
  label: 'Translate Data',
  type: RADIO,
  values: YES_NO_VALUES,
  name: 'translateData',
  defaultValueProp: false,
};

const PREVIEW_ONlY = {
  label: 'Preview Only',
  type: RADIO,
  values: YES_NO_VALUES,
  name: 'previewOnly',
  defaultValueProp: false,
};

const TOOLTIP = {
  label: 'Tooltip',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'dataToolTip',
};

const FORMAT_TYPE = {
  label: 'Format Type',
  type: SELECT,
  name: 'formatType',
  values: FORMAT_TYPE_VALUES,
  defaultValueProp: 'string',
};

const URL = {
  label: 'URL',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'url',
};

const WINDOW_TYPE = {
  label: 'Window Type',
  type: SELECT,
  name: 'linkType',
  values: LINK_TYPE_VALUES,
  defaultValueProp: '2',
};

const BUTTON_TYPE = {
  label: 'Button Type',
  type: SELECT,
  values: BUTTON_TYPE_VALUES,
  name: FORM_MODEL_ATTRIBUTES.BUTTON_TYPE,
};

const BUTTON_BATCH_TYPE = {
  label: 'Button Type',
  type: SELECT,
  values: BUTTON_BATCH_TYPE_VALUES,
  name: FORM_MODEL_ATTRIBUTES.BUTTON_TYPE,
  defaultValueProp: BUTTON_TYPES.SUBMIT_BATCH,
};

const BUTTON_BATCH_ICON = {
  label: 'Icon',
  type: SELECT,
  values: BUTTON_BATCH_ICON_VALUES,
  name: FORM_MODEL_ATTRIBUTES.ICON,
  defaultValueProp: ICON_TYPES.NONE,
};

const BUTTON_BATCH_VIEW_NAME = {
  label: 'View Name',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_VIEW,
};

const BUTTON_BATCH_VIEW_PRIMARY_KEY = {
  label: 'View Primary Key',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_VIEW_PRIMARY_KEY,
};

const BUTTON_BATCH_PARENT_ENTITY_NAME = {
  label: 'Parent Entity Name',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_PARENT_ENTITY_NAME,
};

const BUTTON_BATCH_ENTITY_RECORD_ID = {
  label: 'Entity Record ID',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_ENTITY_RECORD_INSTANCE_ID,
};

const BUTTON_BATCH_CHILD_RECORD_ID = {
  label: 'Child Record ID',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_CHILD_RECORD_INSTANCE_ID,
};

const BUTTON_BATCH_NAME = {
  label: 'Name',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_ENTITY_NAME,
};

const BUTTON_PRIMARY_KEY = {
  label: 'Primary Key',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_PRIMARY_KEY,
};

const BUTTON_BATCH_PRIMARY_KEY_VALUE = {
  label: 'Primary Key Value',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_PRIMARY_KEY_VALUE,
};

const BUTTON_BATCH_USER_CODE = {
  label: 'User Code',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_USER_CODE,
};

const BUTTON_BATCH_STATUS_CODE = {
  label: 'Status Code',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_STATUS_CODE,
};

const BUTTON_BATCH_MODIFIED_DATE = {
  label: 'Modified Date',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_UPDATED_MODIFIED_DATE,
};

const BUTTON_BATCH_CONTAINER_WORKFLOW_KEY = {
  label: 'Container Workflow Key',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_CONTAINER_WORKFLOW_KEY,
};

const BUTTON_BATCH_WORKFLOW_KEY = {
  label: 'Workflow Key',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_WORKFLOW_KEY,
};

const BUTTON_BATCH_WORKFLOW_ID = {
  label: 'Workflow ID',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_WORKFLOW_INSTANCE_ID,
};

const BUTTON_BATCH_WORKFLOW_STEP_ID = {
  label: 'Workflow Step ID',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_WORKFLOW_STEP_INSTANCE_ID,
};

const BUTTON_BATCH_PARENT_WORKFLOW_ID = {
  label: 'Parent Workflow ID',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_PARENT_WORKFLOW_INSTANCE_ID,
};

const BUTTON_BATCH_WORKFLOW_STEP_NAME = {
  label: 'Workflow Step Name',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.BATCH_PROCESS_WORKFLOW_STEP_NAME,
};

const NEED_SIGNATURE = {
  label: 'Need Signature',
  type: RADIO,
  values: YES_NO_VALUES,
  name: FORM_MODEL_ATTRIBUTES.NEED_SIGNATURE,
  defaultValueProp: false,
};

const CAUSES_VALIDATION = {
  label: 'Causes Validation',
  type: RADIO,
  values: YES_NO_VALUES,
  name: FORM_MODEL_ATTRIBUTES.CAUSES_VALIDATION,
  defaultValueProp: false,
};

const CAUSES_VALIDATION_BUTTON = {
  label: 'Causes Validation',
  type: RADIO,
  values: YES_NO_VALUES,
  name: FORM_MODEL_ATTRIBUTES.CAUSES_VALIDATION,
  defaultValueProp: false,
};

const COMMAND_NAME = {
  label: 'Command Name',
  type: SELECT,
  values: COMMAND_NAME_VALUES,
  name: FORM_MODEL_ATTRIBUTES.COMMAND_NAME,
  defaultValueProp: 'Inherit',
};

const COMMAND_ARGUMENT = {
  label: 'Command Argument',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.COMMAND_ARGUMENT,
};

const ICON = {
  label: 'Icon',
  type: TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.ICON,
};

const DISPLAY_ICON = {
  label: 'Icon',
  type: ICON_FIELD,
  name: FORM_MODEL_ATTRIBUTES.DISPLAY_ICON,
};

const DISPLAY_ICON_COLOR = {
  label: 'Icon color',
  type: SELECT,
  values: ICON_COLOR_VALUES,
  name: FORM_MODEL_ATTRIBUTES.DISPLAY_ICON_COLOR,
  defaultValueProp: 'neutral7',
};

const MEANING = {
  label: 'Meaning',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'meaning',
};

const OPERATION_DELAY_MESSAGE = {
  label: 'Operation Delay Message',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'operationDelayMessage',
};

const HEADER_TEXT = {
  label: 'Header Text',
  type: TEXT_FIELD,
  name: 'label',
};

const STYLE = {
  label: 'Style',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'style',
};

const CENTERED = {
  label: 'Centered',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'centered',
};

const IMAGE_OFFSET = {
  label: 'Image Offset',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'offset',
};

const ALTERNATIVE_TEXT = {
  label: 'Alternative Text',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'altText',
};

const ROW_HEADER = {
  label: 'Row Header',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'header',
  defaultValueProp: true,
};

const ROW_TITLE = {
  label: 'Row Title',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'rowTitle',
};

const ALLOW_MAXIMIZE = {
  label: 'Allow Maximize',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'allowMaximizing',
};

const EXPANDABLE_ROWS = {
  label: 'Expandable Rows',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'expandableRows',
  defaultValueProp: false,
};

const DISABLE_PAGINATION = {
  label: 'Disable Pagination',
  type: SELECT,
  values: YES_NO_VALUES,
  name: 'disablePagination',
  defaultValueProp: false,
};

const FIELD_NAME = {
  label: 'Field Name',
  type: SELECT,
  name: 'fieldName',
};

const TERM_HIERARCHY = {
  label: 'Term Hierarchy',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'termHierarchy',
};

const REGULATORY_TERMS = {
  label: 'Regulatory Terms',
  type: CONDITIONAL_SELECT,
  values: REGULATORY_TERMS_VALUES,
  name: 'regulatoryTerms',
};

const ENTITY_NAME_MAPPING = {
  label: 'Entity Name for Mapping',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'mappingEntitName',
};

const FIELD_NAME_MAPPING = {
  label: 'Field Name for Mapping',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'mappingFieldName',
};

const DISABLE_PREDICTION = {
  label: 'Prediction Code',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'predictionCode',
  defaultValueProp: false,
};

const IS_DOCUMENT_CONTENT = {
  label: 'Is Document Content',
  type: SELECT,
  values: YES_VALUE,
  name: 'isDocumentContent',
};

const IS_PORTAL_CONTENT = {
  label: 'Is Portal Document Content',
  type: SELECT,
  values: YES_VALUE,
  name: 'isPortalContent',
};

const FILE_VIEWER_CONTENT_TYPE = {
  label: 'Content Type',
  type: CONDITIONAL_SELECT,
  values: FILE_VIEWER_CONTENT_TYPE_VALUES,
  name: 'contentType',
};

const LATEST_REVISION = {
  label: 'Latest Revision',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'latestRevision',
};

const DOCUMENT_RECORD_ID = {
  label: 'Document Record ID Column',
  type: TEXT_FIELD,
  name: 'documentRecordId',
};

const ENTITY_NAME = {
  label: 'Entity Name',
  type: TEXT_FIELD,
  name: 'entityName',
};

const DOCUMENT_NUMBER = {
  label: 'Document Number',
  type: TEXT_FIELD,
  name: 'documentNumber',
};

const DOCUMENT_REVISION = {
  label: 'Document Revision',
  type: TEXT_FIELD,
  name: 'documentRevision',
};

const DECISION_TREE_NAME = {
  label: 'Decision Tree Name',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'decisionTreeName',
};
const INSPECTION_MEASUREMENT_DATA = {
  label: 'Enter Data',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'inspectionMeasurementData',
};

const ITM_ID = {
  label: 'Itm Id',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'itmId',
};

const CONTAINER_WORKFLOW_KEY = {
  label: 'Container Workflow Key',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'containerWorkflowKey',
};

const WORKFLOW_KEY = {
  label: 'Workflow Key',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'workflowKey',
};

const CURRENT_WORKFLOW_ID = {
  label: 'Current Workflow Id',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'currentWorkFlowId',
};

const STEP_ID = {
  label: 'Step Id',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'stepId',
};

const REGULATORY_CENTER = {
  label: 'Regulatory Center',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'regulatoryCenter',
};

const REGULATORY_BODY = {
  label: 'Regulatory Body',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'regulatoryBody',
};

const FNP_CODE = {
  label: 'FNP Code',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'fnpCode',
};

const IS_APPROVED_FOR_ASR = {
  label: 'Is Approved For ASR',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'isApprovedforASR',
};

const GRID_TYPE = {
  label: 'Grid Type',
  type: SELECT,
  name: 'gridType',
  values: GRID_TYPES_VALUES,
  defaultValueProp: '',
};

const SAVED_SEARCH_TYPE = {
  label: 'Saved Search Type',
  type: SELECT,
  name: 'savedSearchType',
  values: SAVED_SEARCH_TYPE_VALUES,
  defaultValueProp: '',
};

const TOOLTIP_TEXT = {
  label: 'Tooltip Text',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'tooltipText',
};

const TARGET_ID = {
  label: 'Target Id',
  type: SELECT,
  name: 'targetId',
};

const SOURCE_ENTITY = {
  label: 'Source Entity',
  type: TEXT_FIELD,
  name: 'dataObject',
};

const MIN_VALUE = {
  label: 'Min Value',
  type: CONDITIONAL_TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.MIN_VALUE,
  defaultValueProp: 0,
};

const MAX_VALUE = {
  label: 'Max Value',
  type: CONDITIONAL_TEXT_FIELD,
  name: FORM_MODEL_ATTRIBUTES.MAX_VALUE,
  defaultValueProp: 100,
};

const SHOW_INPUT = {
  label: 'Show Input',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: FORM_MODEL_ATTRIBUTES.SHOW_INPUT,
  defaultValueProp: true,
};

const Y_TICKS = {
  label: 'Y-axis ticks',
  type: TEXT_FIELD,
  name: 'yTicks',
};

const SUFFIX = {
  label: 'Suffix',
  type: TEXT_FIELD,
  name: 'suffix',
};

const CHART_DATA = {
  label: 'Chart Data',
  type: CHART_DATA_PROP,
  name: 'chartData',
};

const SOURCE_FIELDS = {
  label: 'Source Fields',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'sourceFields',
};

const EXTRA_PROMPTS = {
  label: 'Extra Prompts',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'extraPrompts',
};

const SHOW_POST_SUMMARY_GENERATION_MESSAGE = {
  label: 'Show Post Summary Generation Message',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'showPostSummaryGenerationMessage',
  defaultValueProp: false,
};

const POST_SUMMARY_GENERATION_MESSAGE = {
  label: 'Post Summary Generation Message',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'postSummaryGenerationMessage',
};

const SUMMARY_GENERATION_DATE = {
  label: 'Summary Generation Date',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'summaryGenerationDate',
};

const SOURCE_ENTITY_NAME = {
  label: 'Source Entity Name',
  type: TEXT_FIELD,
  name: 'sourceEntityName',
};

const SOURCE_RECORD_ID = {
  label: 'Source Record Id',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'sourceRecordId',
};

const OPERATION_COMPLETED_MESSAGE = {
  label: 'Operation Complete Message',
  type: CONDITIONAL_TEXT_FIELD,
  name: 'operationCompleteMessage',
};

const SHOW_OPERATION_COMPLETED_MESSAGE = {
  label: 'Show Operation Complete Message',
  type: CONDITIONAL_SELECT,
  values: YES_NO_CONDITIONAL_VALUES,
  name: 'showOperationCompleteMessage',
  defaultValueProp: true,
};

export const PROPERTIES = {
  ssTextBox: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Lookup',
      properties: [LOOKUP_TYPE, FORCE_VALID_SELECTION],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY, DISABLED_WITH_ZOOM],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssSingleTab: [
    {
      label: 'Appearance',
      properties: [LABEL, DEFAULT_TAB, DISPLAY_ICON, DISPLAY_ICON_COLOR],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, TOOLTIP, VIEW_ONLY],
    },
  ],
  ssTabSet: [],
  ssRadioButtonList: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY],
    },
    {
      label: 'Lookup',
      properties: [DATA_SOURCE_NAME, DATA_VALUE_FIELD, DATA_TEXT_FIELD, DATA_SOURCE_FILTER],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssGrid: [
    {
      label: 'Appearence',
      properties: [TITLE, HEADER],
    },
    {
      label: 'Data',
      properties: [FILTER, SORT],
    },
    {
      label: 'Initialization',
      properties: [INITIAL_EMPTY_ROWS, DATA_SOURCE_NAME, DATA_MAPPING, DATA_SOURCE_FILTER],
    },
    {
      label: 'Behavior',
      properties: [
        REQUIRED,
        HIDDEN,
        VIEW_ONLY,
        DISABLE_ADD,
        DISABLE_EDIT,
        DISABLE_DELETE,
        ENABLE_COPY,
        EXCLUDE_FIELDS_FROM_COPY,
        EDIT_ALL_ROWS,
        ALLOW_SORT,
        ALLOW_MAXIMIZE,
        EXPANDABLE_ROWS,
        DISABLE_PAGINATION,
      ],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER, GRID_TYPE],
    },
  ],

  ssZoom: [
    {
      label: 'Behavior',
      properties: [
        HIDDEN,
        SOURCE_TYPE,
        SOURCE_IDENTIFIER,
        DATA_MAPPING,
        DATA_FILTER,
        QUERY_NAME,
        QUERY_PARAM,
        ALLOW_MULTIPLE_SELECTION,
      ],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],

  ssRegulatoryTermsZoom: [
    {
      label: 'Behavior',
      properties: [HIDDEN, REGULATORY_TERMS, TERM_HIERARCHY],
    },
    {
      label: 'Prediction Code',
      properties: [DISABLE_PREDICTION, ENTITY_NAME_MAPPING, FIELD_NAME_MAPPING],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],

  ssHyperLink: [
    {
      label: 'Appearance',
      properties: [TEXT, URL],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, TOOLTIP, WINDOW_TYPE],
    },

    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssPanel: [
    {
      label: 'Appearance',
      properties: [TITLE, HEADER],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, VIEW_ONLY],
    },

    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssDropDown: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY],
    },
    {
      label: 'Lookup',
      properties: [
        DATA_SOURCE_NAME,
        DATA_VALUE_FIELD,
        DATA_TEXT_FIELD,
        DATA_SOURCE_FILTER,
        DISTINCT_VALUES_ONLY,
        ALLOW_MULTIPLE_SELECTION,
      ],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssTextArea: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY, SUPPORT_RICH_TEXT],
    },

    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssSubForm: [],
  ssTextView: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL],
    },
    {
      label: 'Behavior',
      properties: [FORMAT_TYPE, HIDDEN, TRANSLATE_DATA, PREVIEW_ONlY],
    },
    {
      label: 'Appearance',
      properties: [TOOLTIP],
    },
    {
      label: 'HyperLink',
      properties: [URL, WINDOW_TYPE],
    },
  ],
  ssButton: [
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Behavior',
      properties: [
        HIDDEN,
        BUTTON_TYPE,
        NEED_SIGNATURE,
        CAUSES_VALIDATION_BUTTON,
        COMMAND_NAME,
        COMMAND_ARGUMENT,
        OPERATION_DELAY_MESSAGE,
      ],
    },
    {
      label: 'Sign-off Screen Configuration',
      properties: [MEANING],
    },
  ],
  ssButtonBulkUpload: [
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, NEED_SIGNATURE, CAUSES_VALIDATION, OPERATION_DELAY_MESSAGE],
    },
  ],
  ssButtonSharePoint: [
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssButtonDecisionTree: [
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Decision Tree Configuration',
      properties: [
        DECISION_TREE_NAME,
        ITM_ID,
        CONTAINER_WORKFLOW_KEY,
        WORKFLOW_KEY,
        CURRENT_WORKFLOW_ID,
        STEP_ID,
        REGULATORY_CENTER,
        REGULATORY_BODY,
        FNP_CODE,
        IS_APPROVED_FOR_ASR,
      ],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssButtonBatch: [
    {
      label: 'Behavior',
      properties: [
        HIDDEN,
        BUTTON_BATCH_TYPE,
        NEED_SIGNATURE,
        CAUSES_VALIDATION_BUTTON,
        OPERATION_DELAY_MESSAGE,
      ],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'General Batch Info',
      properties: [
        BUTTON_BATCH_VIEW_NAME,
        BUTTON_BATCH_VIEW_PRIMARY_KEY,
        BUTTON_BATCH_PARENT_ENTITY_NAME,
        BUTTON_BATCH_ENTITY_RECORD_ID,
        BUTTON_BATCH_CHILD_RECORD_ID,
      ],
    },
    {
      label: 'Entity Columns - Required for Updating Batch Progress',
      properties: [
        BUTTON_BATCH_NAME,
        BUTTON_PRIMARY_KEY,
        BUTTON_BATCH_PRIMARY_KEY_VALUE,
        BUTTON_BATCH_USER_CODE,
        BUTTON_BATCH_STATUS_CODE,
        BUTTON_BATCH_MODIFIED_DATE,
      ],
    },
    {
      label: 'Workflow Keys',
      properties: [BUTTON_BATCH_CONTAINER_WORKFLOW_KEY, BUTTON_BATCH_WORKFLOW_KEY],
    },
    {
      label: 'Workflow - Required for Persistent Tasks',
      properties: [BUTTON_BATCH_WORKFLOW_ID, BUTTON_BATCH_WORKFLOW_STEP_ID],
    },
    {
      label: 'Workflow - Required for Non-Persistent Tasks',
      properties: [BUTTON_BATCH_PARENT_WORKFLOW_ID, BUTTON_BATCH_WORKFLOW_STEP_NAME],
    },
  ],
  ssInspectionMeasurementDataButton: [
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssGridColumn: [
    {
      label: 'Data',
      properties: [FIELD_NAME],
    },
    {
      label: 'Text',
      properties: [HEADER_TEXT],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
  ],
  ssDateBox: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssNumericTextBox: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY, STEP_SIZE],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssCheckBox: [
    {
      label: 'Data',
      properties: [CONTROL_TYPE, LABEL, INITIAL_VALUE, SET_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssStaticText: [
    {
      label: 'Appearance',
      properties: [TEXT, STYLE, CENTERED, DISPLAY_ICON, DISPLAY_ICON_COLOR],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, TOOLTIP, TRANSLATE_DATA],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssImage: [
    {
      label: 'Behavior',
      properties: [HIDDEN, TOOLTIP],
    },
    {
      label: 'Appearance',
      properties: [HEIGHT, IMAGE_OFFSET, ALTERNATIVE_TEXT, URL],
    },
  ],
  ssButtonOfficeOnline: [
    {
      label: 'Behavior',
      properties: [HIDDEN, OFFICE_ONLINE_OPTIONS],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssRepositoryZoom: [
    {
      label: 'Behavior',
      properties: [HIDDEN, QUERY_PARAM],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssSavedSearch: [
    {
      label: 'Appearance',
      properties: [EMPTY_SECTION_MESSAGE],
    },
    {
      label: 'Saved Search',
      properties: [
        DATASOURCE_SOURCE_TYPE,
        SOURCE_IDENTIFIER,
        DATA_FILTER,
        SAVED_SEARCH_NAME,
        QUERY_PARAM,
      ],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER, SAVED_SEARCH_TYPE],
    },
  ],
  ssFileInput: [
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, VIEW_ONLY],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssButtonControlledPrintRequest: [
    {
      label: 'Behavior',
      properties: [HIDDEN, NEED_SIGNATURE],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Sign-off Screen Configuration',
      properties: [MEANING],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssScormFileInput: [
    {
      label: 'Behavior',
      properties: [SCORM_CONTENT_TYPE, REQUIRED, HIDDEN, VIEW_ONLY],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssFileViewer: [
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Data',
      properties: [
        ENTITY_NAME,
        DOCUMENT_RECORD_ID,
        DOCUMENT_NUMBER,
        DOCUMENT_REVISION,
        LATEST_REVISION,
        FILE_VIEWER_CONTENT_TYPE,
        IS_DOCUMENT_CONTENT,
        IS_PORTAL_CONTENT,
      ],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssForm: [
    {
      label: 'Help Link',
      properties: [FORM_HELP_LINK_TEXT, FORM_HELP_LINK_URL],
    },
    {
      label: 'Behavior',
      properties: [FORM_DESCRIPTION],
    },
    {
      label: 'On Change',
      properties: [VALIDATION_ACTIONS, UPDATE_ACTIONS, INTERACTION_ACTIONS],
    },
    {
      label: 'Data Sources',
      properties: [DATASOURCES_LIST],
    },
  ],
  ssRepeatingPanel: [
    {
      label: 'Appearance',
      properties: [ROW_TITLE, ROW_HEADER],
    },
    {
      label: 'Data',
      properties: [FILTER],
    },
    {
      label: 'Initialization',
      properties: [INITIAL_EMPTY_ROWS, DATA_SOURCE_NAME, DATA_MAPPING, DATA_SOURCE_FILTER],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, VIEW_ONLY, DISABLE_ADD, DISABLE_EDIT, DISABLE_DELETE],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssFieldGroup: [
    {
      label: 'Appearance',
      properties: [TITLE, ORIENTATION],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssModal: [
    {
      label: 'Appearance',
      properties: [TOOLTIP_TEXT],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, VIEW_ONLY, SOURCE_ENTITY, TARGET_ID, DATA_MAPPING],
    },
  ],
  ssButtonScorm: [
    {
      label: 'Behavior',
      properties: [HIDDEN, SCORM_LAUNCH_OPTIONS, SCORM_CONTENT_TYPE],
    },
    {
      label: 'Appearance',
      properties: [LABEL],
    },
    {
      label: 'Misc',
      properties: [UNIQUE_IDENTIFIER],
    },
  ],
  ssSlider: [
    {
      label: 'Data',
      properties: [LABEL, INITIAL_VALUE, SET_VALUE, MIN_VALUE, MAX_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY, SHOW_INPUT],
    },
    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssIcon: [
    {
      label: 'Appearance',
      properties: [ICONS_LIST, ICON_COLOR, ICON_FONT_SIZE],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, TOOLTIP],
    },
  ],
  ssClusterColumnChart: [
    {
      label: 'Data',
      properties: [CHART_DATA],
    },
    {
      label: 'Appearance',
      properties: [TITLE, HEADER, WIDTH, HEIGHT],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, Y_TICKS, SUFFIX],
    },
  ],
  ssSummary: [
    {
      label: 'Data',
      properties: [LABEL, INITIAL_VALUE],
    },
    {
      label: 'Behavior',
      properties: [REQUIRED, HIDDEN, TOOLTIP, VIEW_ONLY],
    },
    {
      label: 'Summary Configuration',
      properties: [
        SOURCE_FIELDS,
        EXTRA_PROMPTS,
        SUMMARY_GENERATION_DATE,
        SHOW_POST_SUMMARY_GENERATION_MESSAGE,
        POST_SUMMARY_GENERATION_MESSAGE,
      ],
    },

    {
      label: 'On Change',
      properties: [VALIDATE, UPDATE],
    },
  ],
  ssSimilarRecords: [
    {
      label: 'Data',
      properties: [SOURCE_ENTITY_NAME, SOURCE_RECORD_ID],
    },
    {
      label: 'Display',
      properties: [SOURCE_IDENTIFIER, SAVED_SEARCH_NAME],
    },
    {
      label: 'Behavior',
      properties: [HIDDEN, SHOW_OPERATION_COMPLETED_MESSAGE, OPERATION_COMPLETED_MESSAGE],
    },
  ],
  ssRoleActorsManagement: [
    {
      label: 'Behavior',
      properties: [HIDDEN],
    },
  ],
};
